import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Home, ArrowRight } from "lucide-react";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1 pt-[180px] pb-24">
        <div className="max-w-3xl mx-auto px-5 md:px-8 text-center">
          <p className="text-[12px] tracking-[0.22em] uppercase text-[hsl(var(--rc-purple))] font-semibold">
            404
          </p>
          <h1 className="font-serif-display mt-4 text-[44px] md:text-[64px] leading-[1.05] font-semibold text-[hsl(var(--rc-deep))]">
            We can’t find that page.
          </h1>
          <p className="mt-5 text-[16.5px] leading-[1.7] text-[hsl(var(--rc-slate))] max-w-xl mx-auto">
            The page may have moved — or maybe we just took a wrong turn. Let’s get you back on track.
          </p>
          <Link
            to="/"
            className="mt-8 inline-flex items-center gap-2 px-6 h-12 rounded-full bg-[hsl(var(--rc-deep))] hover:bg-[hsl(var(--rc-purple))] text-white text-[14px] font-medium transition-colors"
          >
            <Home className="w-4 h-4" /> Back to home <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFoundPage;
